import {
  Container,
  Grid,
  Box,
  makeStyles,
  Slide,
  Fade,
  Grow,
  Typography,
  Chip,
} from "@material-ui/core";
import WorkOutlineIcon from "@material-ui/icons/WorkOutline";
import LocationOnOutlinedIcon from "@material-ui/icons/LocationOnOutlined";
import BusinessCenterIcon from "@material-ui/icons/BusinessCenter";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Axios from "axios";
import { Helmet } from "react-helmet-async";
import { Loading } from "../../components/shared/loading";
import parse from "html-react-parser";
import { HeroParticles } from "../../components/shared/HeroParticles";

const headKey = "qweqeasdj123n1jasndjn2j3njsdn12i891bdjsdu1283djsd1231231";

const useStyles = makeStyles((theme) => ({
  "@keyframes heroFadeUp": {
    from: { opacity: 0, transform: "translateY(24px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  },
  "@keyframes heroExpand": {
    from: { width: 0, opacity: 0 },
    to: { width: 90, opacity: 1 },
  },
  "@keyframes heroShimmerSweep": {
    "0%": { backgroundPosition: "-200% center" },
    "100%": { backgroundPosition: "200% center" },
  },
  // ── HERO ──
  heroSection: {
    position: "relative",
    overflow: "hidden",
    minHeight: "45vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #1a001a 0%, #2d002d 100%)",
    [theme.breakpoints.down("sm")]: {
      minHeight: "38vh",
    },
  },
  heroContent: {
    position: "relative",
    zIndex: 1,
    textAlign: "center",
    color: "#ffffff",
    padding: "40px 20px",
    maxWidth: 700,
    [theme.breakpoints.down("xs")]: {
      padding: "32px 16px",
    },
  },
  heroTitle: {
    fontSize: "clamp(1.8rem, 4vw, 2.5rem)",
    fontWeight: 700,
    marginBottom: 10,
    backgroundImage:
      "linear-gradient(90deg, #ffffff 0%, #e0b8e0 25%, #c77dc7 50%, #e0b8e0 75%, #ffffff 100%)",
    backgroundSize: "200% auto",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
    color: "transparent",
    animation:
      "$heroFadeUp 0.9s cubic-bezier(0.22, 1, 0.36, 1) 0.15s both, $heroShimmerSweep 5s linear infinite",
  },
  heroDivider: {
    width: 90,
    height: 3,
    background:
      "linear-gradient(90deg, transparent, #c77dc7 30%, #e0b8e0 50%, #c77dc7 70%, transparent)",
    margin: "16px auto",
    borderRadius: 2,
    animation: "$heroExpand 0.9s cubic-bezier(0.22, 1, 0.36, 1) 0.55s both",
  },
  heroSubtitle: {
    fontSize: "clamp(0.85rem, 1.5vw, 1rem)",
    fontWeight: 400,
    opacity: 0.9,
    maxWidth: 500,
    margin: "0 auto",
    lineHeight: 1.5,
    animation: "$heroFadeUp 0.9s cubic-bezier(0.22, 1, 0.36, 1) 0.5s both",
  },

  section: {
    padding: "48px 0 56px",
    background: "#fafafa",
    minHeight: "50vh",
    [theme.breakpoints.down("xs")]: {
      padding: "32px 0 40px",
    },
  },
  sectionTitle: {
    fontSize: "1.4rem",
    fontWeight: 600,
    color: "#4c004c",
    textAlign: "center",
    marginBottom: 8,
    [theme.breakpoints.down("xs")]: {
      fontSize: "1.15rem",
    },
  },
  sectionSubtitle: {
    fontSize: "0.85rem",
    color: "#666666",
    textAlign: "center",
    maxWidth: 480,
    margin: "0 auto 32px",
    lineHeight: 1.5,
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.78rem",
      margin: "0 auto 24px",
      padding: "0 8px",
    },
  },

  // ── FILTERS ──
  filterBar: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
    gap: 8,
    marginBottom: 40,
    background: "#ffffff",
    borderRadius: 14,
    padding: "16px 24px",
    boxShadow: "0 2px 16px rgba(0,0,0,0.04)",
    border: "1px solid rgba(0,0,0,0.04)",
    [theme.breakpoints.down("sm")]: {
      padding: "14px 16px",
      gap: 6,
      marginBottom: 28,
      borderRadius: 12,
    },
    [theme.breakpoints.down("xs")]: {
      padding: "12px 12px",
      gap: 5,
    },
  },
  filterChip: {
    borderRadius: 8,
    fontSize: "0.7rem",
    fontWeight: 500,
    height: 32,
    [theme.breakpoints.down("xs")]: {
      height: 28,
      fontSize: "0.62rem",
    },
    border: "1px solid rgba(76,0,76,0.12)",
    background: "transparent",
    color: "#555",
    cursor: "pointer",
    transition: "all 0.25s ease",
    letterSpacing: "0.2px",
    "&:hover": {
      background: "rgba(76,0,76,0.04)",
      borderColor: "rgba(76,0,76,0.25)",
      color: "#4c004c",
    },
    "&:focus": {
      background: "rgba(76,0,76,0.04)",
    },
  },
  filterChipActive: {
    borderRadius: 8,
    fontSize: "0.7rem",
    fontWeight: 600,
    height: 32,
    [theme.breakpoints.down("xs")]: {
      height: 28,
      fontSize: "0.62rem",
    },
    background: "#4c004c",
    color: "#ffffff",
    border: "1px solid #4c004c",
    cursor: "pointer",
    letterSpacing: "0.2px",
    boxShadow: "0 2px 8px rgba(76,0,76,0.18)",
    "&:hover": {
      background: "#5a0a5a",
    },
    "&:focus": {
      background: "#5a0a5a",
    },
  },
  filterLabel: {
    fontSize: "0.62rem",
    fontWeight: 700,
    color: "#aaa",
    textTransform: "uppercase",
    letterSpacing: "1.8px",
    marginRight: 2,
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.56rem",
      width: "100%",
      textAlign: "center",
      marginRight: 0,
      marginTop: 4,
    },
  },
  filterDivider: {
    width: 1,
    height: 24,
    background: "rgba(0,0,0,0.06)",
    margin: "0 10px",
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },

  // ── JOB CARDS ──
  "@keyframes cardShimmer": {
    "0%": { backgroundPosition: "200% 0" },
    "100%": { backgroundPosition: "-200% 0" },
  },
  jobCard: {
    borderRadius: 14,
    width: "100%",
    background: "#ffffff",
    overflow: "hidden",
    border: "1px solid rgba(0,0,0,0.05)",
    boxShadow: "0 1px 8px rgba(0,0,0,0.03)",
    transition: "all 0.45s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
    position: "relative",
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    "&::after": {
      content: '""',
      position: "absolute",
      bottom: 0,
      left: 0,
      width: 0,
      height: 3,
      background: "linear-gradient(90deg, #4c004c, #9b3b9b, #4c004c)",
      transition: "width 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
    },
    "&:hover": {
      transform: "translateY(-10px)",
      boxShadow: "0 24px 56px rgba(76,0,76,0.13), 0 0 0 1px rgba(76,0,76,0.04)",
    },
    "&:hover::after": {
      width: "100%",
    },
    "&:hover $jobCardHeader": {
      backgroundSize: "100% 100%",
    },
    "&:hover $jobIconWrap": {
      background: "rgba(255,255,255,0.15)",
      transform: "scale(1.08)",
    },
    "&:hover $jobViewMore": {
      letterSpacing: "0.8px",
    },
  },
  jobCardHeader: {
    background: "linear-gradient(135deg, #4c004c 0%, #3a003a 100%)",
    padding: "22px 24px 18px",
    position: "relative",
    transition: "background-size 0.5s ease",
    backgroundSize: "100% 100%",
    [theme.breakpoints.down("xs")]: {
      padding: "18px 16px 14px",
    },
  },
  jobIconWrap: {
    width: 36,
    height: 36,
    borderRadius: 10,
    background: "rgba(255,255,255,0.08)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 14,
    transition: "all 0.4s ease",
    "& svg": {
      fontSize: "1.1rem",
      color: "rgba(255,255,255,0.7)",
    },
  },
  jobTitle: {
    fontSize: "0.9rem",
    fontWeight: 600,
    color: "#ffffff",
    lineHeight: 1.4,
    marginBottom: 10,
  },
  jobBadges: {
    display: "flex",
    flexWrap: "wrap",
    gap: 6,
  },
  jobBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    fontSize: "0.58rem",
    fontWeight: 500,
    color: "rgba(255,255,255,0.7)",
    background: "rgba(255,255,255,0.08)",
    borderRadius: 6,
    padding: "3px 8px",
    letterSpacing: "0.2px",
    "& svg": {
      fontSize: "0.68rem",
    },
  },
  jobCardBody: {
    padding: "20px 24px 22px",
    flex: 1,
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("xs")]: {
      padding: "16px 16px 18px",
    },
  },
  jobDescription: {
    fontSize: "0.73rem",
    color: "#777",
    lineHeight: 1.7,
    overflow: "hidden",
    display: "-webkit-box",
    "-webkit-line-clamp": 4,
    "-webkit-box-orient": "vertical",
    flex: 1,
    "& h1, & h2, & h3, & h4, & h5, & h6": {
      fontSize: "0.76rem",
      fontWeight: 600,
      color: "#333",
      margin: "0 0 6px",
    },
    "& ul, & ol": {
      paddingLeft: 18,
      margin: "4px 0",
    },
    "& li": {
      fontSize: "0.73rem",
      color: "#777",
      marginBottom: 2,
    },
    "& p": {
      margin: "0 0 6px",
    },
  },
  jobViewMore: {
    marginTop: 14,
    fontSize: "0.68rem",
    fontWeight: 600,
    color: "#4c004c",
    letterSpacing: "0.4px",
    textTransform: "uppercase",
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    transition: "all 0.35s ease",
  },

  // ── EMPTY STATE ──
  emptyState: {
    textAlign: "center",
    padding: "60px 20px",
  },
  emptyIcon: {
    fontSize: "3rem",
    color: "rgba(76,0,76,0.12)",
    marginBottom: 16,
  },
  emptyText: {
    fontSize: "0.88rem",
    color: "#999",
    fontWeight: 500,
  },
  emptySubtext: {
    fontSize: "0.75rem",
    color: "#bbb",
    marginTop: 4,
  },
}));

const formatLabel = (str) => {
  if (!str) return "";
  return str
    .replace(/[-_]/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
};

export const Careers = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [jobs, setJobs] = useState([]);
  const [filteredJobs, setFilteredJobs] = useState([]);
  const [isloading, setIsloading] = useState(true);
  const [jobTypeFilter, setJobTypeFilter] = useState("all");
  const [workTypeFilter, setWorkTypeFilter] = useState("all");
  const [metaTitle, setMetaTitle] = useState("");
  const [metaDesc, setMetaDesc] = useState("");
  const [metaKeywords, setMetaKeywords] = useState("");

  useEffect(() => {
    getMetaData();
  }, []);

  useEffect(() => {
    let result = [...jobs];
    if (jobTypeFilter !== "all") {
      result = result.filter(
        (j) => j.job_type?.toLowerCase() === jobTypeFilter.toLowerCase()
      );
    }
    if (workTypeFilter !== "all") {
      result = result.filter(
        (j) => j.work_type?.toLowerCase() === workTypeFilter.toLowerCase()
      );
    }
    setFilteredJobs(result);
  }, [jobs, jobTypeFilter, workTypeFilter]);

  const getMetaData = async () => {
    const formData = new FormData();
    formData.append("page", 9);
    await Axios.post("/api/getmetadata", formData, {
      headers: { headKey: headKey },
    }).then((res) => {
      if (res.data.status) {
        setMetaTitle(res.data.data.meta_title);
        setMetaKeywords(res.data.data.meta_keywords);
        setMetaDesc(res.data.data.meta_desc);
      }
    });
    await fetchJobs();
  };

  const fetchJobs = async () => {
    try {
      const res = await Axios.get("/api/get_jobs", {
        headers: { headKey: headKey },
      });
      if (res.data.status) {
        setJobs(res.data.data);
        setFilteredJobs(res.data.data);
      }
    } catch (err) {
      console.error("Failed to fetch jobs:", err);
    } finally {
      setIsloading(false);
      handleClick();
    }
  };

  const jobTypes = ["all", "full_time", "part_time", "internship", "contract"];
  const workTypes = ["all", "remote", "location", "hybrid"];

  const handleClick = () => {
    const anchor = document.querySelector("#back-to-top-anchor");
    if (anchor) {
      anchor.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  return (
    <div>
      <Helmet>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDesc} />
        <meta name="keywords" content={metaKeywords}></meta>
      </Helmet>

      {/* Hero Section */}
      <Box className={classes.heroSection}>
        <HeroParticles id="careers-hero-particles" />
        <Box className={classes.heroContent}>
          <Typography className={classes.heroTitle}>Careers</Typography>
          <Box className={classes.heroDivider} />
          <Typography className={classes.heroSubtitle}>
            Join our team of innovators building tomorrow's technology
          </Typography>
        </Box>
      </Box>

      {isloading ? (
        <Loading />
      ) : (
        <Box className={classes.section}>
          <Container maxWidth="lg">
            <Slide direction="up" in={true} timeout={800}>
              <Box>
                <Typography className={classes.sectionTitle}>
                  Open Positions
                </Typography>
                <Typography className={classes.sectionSubtitle}>
                  Find your perfect role and grow with us
                </Typography>
              </Box>
            </Slide>

            {/* Filters */}
            <Fade in={true} timeout={1000}>
              <Box className={classes.filterBar}>
                <Typography className={classes.filterLabel}>Job Type</Typography>
                {jobTypes.map((type) => (
                  <Chip
                    key={`jt-${type}`}
                    label={formatLabel(type)}
                    className={
                      jobTypeFilter === type
                        ? classes.filterChipActive
                        : classes.filterChip
                    }
                    onClick={() => setJobTypeFilter(type)}
                  />
                ))}
                <Box className={classes.filterDivider} />
                <Typography className={classes.filterLabel}>Work Type</Typography>
                {workTypes.map((type) => (
                  <Chip
                    key={`wt-${type}`}
                    label={formatLabel(type)}
                    className={
                      workTypeFilter === type
                        ? classes.filterChipActive
                        : classes.filterChip
                    }
                    onClick={() => setWorkTypeFilter(type)}
                  />
                ))}
              </Box>
            </Fade>

            {/* Job Cards */}
            {filteredJobs.length > 0 ? (
              <Grid container spacing={3}>
                {filteredJobs.map((job, index) => (
                  <Grid item xs={12} sm={6} md={4} key={job.id || index}>
                    <Grow in={true} timeout={800 + index * 120}>
                      <Box
                        className={classes.jobCard}
                        onClick={() => navigate(`/careers/${job.id}`)}
                      >
                        <Box className={classes.jobCardHeader}>
                          <Box className={classes.jobIconWrap}>
                            <BusinessCenterIcon />
                          </Box>
                          <Typography className={classes.jobTitle}>
                            {job.title}
                          </Typography>
                          <Box className={classes.jobBadges}>
                            {job.job_type && (
                              <Box className={classes.jobBadge}>
                                <BusinessCenterIcon />
                                {formatLabel(job.job_type)}
                              </Box>
                            )}
                            {job.work_type && (
                              <Box className={classes.jobBadge}>
                                <WorkOutlineIcon />
                                {formatLabel(job.work_type)}
                              </Box>
                            )}
                            {job.location && (
                              <Box className={classes.jobBadge}>
                                <LocationOnOutlinedIcon />
                                {job.location}
                              </Box>
                            )}
                          </Box>
                        </Box>
                        <Box className={classes.jobCardBody}>
                          <Box className={classes.jobDescription}>
                            {job.description ? parse(job.description) : ""}
                          </Box>
                          <Typography className={classes.jobViewMore}>
                            View Details →
                          </Typography>
                        </Box>
                      </Box>
                    </Grow>
                  </Grid>
                ))}
              </Grid>
            ) : (
              <Fade in={true} timeout={800}>
                <Box className={classes.emptyState}>
                  <WorkOutlineIcon className={classes.emptyIcon} />
                  <Typography className={classes.emptyText}>
                    No positions match your filters
                  </Typography>
                  <Typography className={classes.emptySubtext}>
                    Try adjusting your filters or check back later
                  </Typography>
                </Box>
              </Fade>
            )}
          </Container>
        </Box>
      )}

    </div>
  );
};
